import { UpdateParticipantPayload, UpdatedParticipantItem } from "@dune/types";
import { getErrorMessage } from "@dune/vars";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { privateAxios } from "../axios";
import { participantsQueryKeys } from "../query-keys/participants.query-keys";

const updateParticipant = async (params: {
	id: number;
	data: UpdateParticipantPayload;
}): Promise<UpdatedParticipantItem> => {
	const { data } = await privateAxios.patch(
		`/contractors/${params.id}`,
		params.data,
	);
	return data;
};

export const useUpdateParticipant = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: updateParticipant,
		onSuccess: (updatedContractor) => {
			toast.success("Participant mis à jour avec succès");

			queryClient.invalidateQueries({
				queryKey: participantsQueryKeys.lists(),
			});
			queryClient.invalidateQueries({
				queryKey: participantsQueryKeys.detail(updatedContractor.id),
			});
		},
		onError: (error) => {
			const errorMessage = getErrorMessage(error);
			toast.error("Erreur lors de la mise à jour du participant", {
				description: errorMessage,
			});
		},
	});
};

const deleteParticipant = async (id: number): Promise<void> => {
	await privateAxios.delete(`/contractors/${id}`);
};

export const useDeleteParticipant = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: deleteParticipant,
		onSuccess: () => {
			toast.success("Participant supprimé avec succès");

			queryClient.invalidateQueries({
				queryKey: participantsQueryKeys.lists(),
			});
		},
		onError: (error) => {
			const errorMessage = getErrorMessage(error);
			toast.error("Erreur lors de la suppression du participant", {
				description: errorMessage,
			});
		},
	});
};
